import { render, staticRenderFns } from "./StaffContent.vue?vue&type=template&id=7225604d"
import script from "./StaffContent.vue?vue&type=script&lang=js"
export * from "./StaffContent.vue?vue&type=script&lang=js"
import style0 from "./StaffContent.vue?vue&type=style&index=0&id=7225604d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports